import { computed } from 'vue'
import { TImageData, TImageFocalPoint } from '~/types/components/image-types'
import { resizeToFocalPoint } from '~/utils/image-conversions'

// turns a directus image has into an url, cutout based on focal point
export const useImageFocal = (
  image: TImageData,
  width: number | string,
  height: number | string,
  focalPoint?: TImageFocalPoint,
  format = 'jpg',
  quality = 65
) => {
  return computed((): string => {
    // TODO: nice placeholder image
    if (!image?.id) {
      return '#'
    }

    let imageUrl = `${image.id}`

    const params = new URLSearchParams()

    params.set('format', format.toString() || 'jpg')
    params.set('quality', quality.toString() || '65')
    params.set('withoutEnlargement', 'true')

    if (width === 'auto' || height === 'auto') {
      if (width !== 'auto') {
        params.set('width', width.toString())
      }

      if (height !== 'auto') {
        params.set('height', height.toString())
      }

      return imageUrl + `?${params.toString()}`
    }

    // make sure we have a focal point value (which we should)
    const normalizedFocalPoint = (focalPoint?.zoom) ? focalPoint?.zoom : 0

    const { width: calculatedWidth, height: calculatedHeight, region } = resizeToFocalPoint(
      { width: image.width || 0, height: image.height || 0 },
      { width, height },
      { x: (focalPoint?.x / 100) * image.width, y: (focalPoint?.y / 100) * image.height },
      normalizedFocalPoint + 1
    )

    const transforms = [
      ['resize', { width: calculatedWidth, height: calculatedHeight }],
      ['extract', region]
    ]

    params.set('transforms', JSON.stringify(transforms))

    // TODO: currently unused, this is an attempt to fix the rendition creation 'issue'
    // const combinedKey = usePreset(
    //   params.get('format'),
    //   params.get('quality'),
    //   params.get('withoutEnlargement'),
    //   calculatedWidth,
    //   calculatedHeight,
    //   region,
    //   transforms
    // )

    // params.set('key', combinedKey)
    // imageUrl + `?key=${combinedKey}`

    const stringParams = params.toString()
    if (stringParams && stringParams !== '') {
      imageUrl += `?${stringParams}`
    }

    return imageUrl
  })
}
